module.exports = __webpack_public_path__ + "static/intowVideo-57d172b94dcd9dffa8a62f0e8e064e67.mp4";